export function BuildCSS(newBanner) {
  var banner = JSON.parse(JSON.stringify(newBanner));
  var animation = [];
  try {
    for (var i = 0; i < banner.preset.length; i++) {
      var time = 0;
      var preset = banner.preset[i];
      for (var j = 0; j <= i; j++) {
        if(preset.parent || banner.preset[j].parent === preset.parent) {
          time = time + parseFloat(banner.preset[j].delay) * 1000;
        }
      }
      var loop = banner.elements.find(x => x.id === preset.name).loop;
      loop = loop === -1 ? 'infinite' : loop;
      var duration = preset.customKeyframe ? preset.customKeyframe.duration : preset.duration
      var animationName = preset.customKeyframe ?
        preset.customKeyframe.keyframeName :
        `${preset.animation}_${preset.direction}_${duration}_${preset.type}`
      if (loop === 'infinite' || loop > 1) {
        animationName = `${animationName}_iteration_${loop}`
      }
      animation.push({
        id: preset.name,
        animation: `${animationName} ${duration}ms ${loop === -1 ? 'infinite' : loop} forwards ${time}ms`,
        aux: false}
      );
    }

    var animation2 = [];
    for (var i = 0; i < animation.length; i++) {
      var teste = "";
      for (var j = i; j < animation.length; j++) {
        if (animation[j].id === animation[i].id && !animation[j].aux) {
          if (teste !== "") teste += ", ";
          teste += animation[j].animation;
          animation[j].aux = true;
        }
      }
      if (teste !== "") {
        teste += ";"
        animation2.push({id: animation[i].id, animation: teste});
      }
    }

    var html = `<html>
      <head>
        <meta charset="UTF-8">
        <meta name="apple-mobile-web-app-capable" content="yes">
        <meta name="viewport" content="minimum-scale=1,maximum-scale=1,width=device-width,user-scalable=no">
        <meta name="ad.size" content="width=${banner.width},height=${banner.height}">
            <!-- /* a cima dimensão do banner */ -->
        <script type="text/javascript">
            var clickTag = "http://www.google.com"
        </script>
        <title>Reanimate_${banner.width}x${banner.height}</title>
            <!-- /* a nomeclatura da peça */ -->
        <style>
          body {
            margin: 0;
            padding: 0;
            width: ${banner.width}px;
            height: ${banner.height};
            position: relative;
          }

          #clickArea {
              position: absolute;
              top: 0;
              left: 0;
              z-index: 999
          }

          #clickArea img {
              border: 0
          }

          #banner {
              -moz-box-sizing: border-box;
              -webkit-box-sizing: border-box;
              -webkit-user-select: none;
              -ms-user-select: none;
              user-select: none;
              box-sizing: border-box;
              overflow: hidden;
              position: relative;
              width: ${banner.width}px;
              height: ${banner.height}px;
              top: 0;
              left: 0;
              cursor: pointer;
              background-color: ${banner.backgroundColor === undefined ? '#fff' : banner.backgroundColor}
          }
          
          #banner:after {
            position: absolute;
            content: '';
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: 900
        }

        body {
          overflow: hidden;
        }

        #banner:before {
            position: absolute;
            content: '';
            left: 0;
            top: 0;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            z-index: 901;
        }`

    banner.elements.forEach(async (el) => {
      if (el.step > -1) {
        html += `
        .${el.id} {
          ${el.properties.background ? `background: url('${el.properties.background}') no-repeat;` : ""}          
          width: ${Math.ceil(el.properties.width * el.properties.scale / 100)}px;
          height: ${Math.ceil(el.properties.height * el.properties.scale / 100)}px;
          left: ${el.properties.left}px;
          top: ${el.properties.top}px;
          position: absolute;
          opacity: ${el.properties.opacity};
          z-index: ${el.properties.zIndex};
          animation: ${getAnimation(animation2, el.id).toLowerCase()}
          animation-play-state: paused;
          ${el.reduce ? '' : 'background-size: contain;'}
        }`  
      }
    });
    html += "</style>";
    html += banner.animation.toLowerCase();
    html += "</head>";
    html += banner.body;

    let delayVideo = 0;
    try {

      const video = banner.elements.filter(x => x.properties.type === "video");
      if (video.length > 0) {
        delayVideo = video[0].animation.in.delay * 1000;
      }
    } catch {}


    html += `
    <script>
    
      try {
        window.onload = function () {
          const video = document.getElementsByTagName('video')[0];
          setTimeout(() => {}, 10);
          video.play();
          setTimeout(() => {}, 10);
          video.pause();
        }
      } catch {}  

      try {
        document.getElementById("sound-on").style.display = 'none';
        document.getElementById("sound-off").style.display = 'none';
      } catch {}
       
      const delayVideo = ${delayVideo};
      let timeVideo = 0;

      function setTime(time) {
        try {
          const video = document.getElementsByTagName('video')[0];
          timeVideo += time;
          video.currentTime = (timeVideo - delayVideo) / 1000;
          console.log(video.currentTime, (timeVideo - delayVideo) / 1000);
        } catch (error) { console.log(error); }

        var elements = document.querySelectorAll('#banner div,#banner video');
        for (var i = 0; i < elements.length; i++) {
          let currStyle = window.getComputedStyle(elements[i]);
          var delays = currStyle.getPropertyValue('animation-delay').split(',');
          var d1 = (parseFloat(delays[0].replace("s", "")) * 1000 - time) / 1000 + "s"
          var d2 = "";
          if (delays.length === 2) {
            d2 = "," + (parseFloat(delays[1].replace("s", "")) * 1000 - time) / 1000 + "s"
          }
          elements[i].style.setProperty('animation-delay', d1 + d2);
        }
      }
    setTime(0);
    </script>
    `
    html += "</html>";
    html = html.replaceAll("function animabanner() {", "function animabanner () {");
    html = html.replaceAll("animabanner()", "//animabanner()");
    return html;
  } catch {}
}

function getAnimation(animation, id) {
  var a = "";
  animation.forEach(element => {
    if (element.id === id) a = element.animation;
  });
  return a;
}

export function ConvertBannerTimeline(banner) {
  var html = `<html>              
  <head>
      <meta charset="UTF-8">
      <meta name="apple-mobile-web-app-capable" content="yes">
      <meta name="viewport" content="minimum-scale=1,maximum-scale=1,width=device-width,user-scalable=no">
      <meta name="ad.size" content="width=${banner.width},height=${banner.height}">
          <!-- /* a cima dimensão do banner */ -->
      <script type="text/javascript">
          var clickTag = "http://www.google.com"
      </script>
      <title>Reanimate_${banner.width}x${banner.height}</title>
          <!-- /* a nomeclatura da peça */ -->
      <style>
        body {
          margin: 0;
          padding: 0;
          width: ${banner.width}px;
          height: ${banner.height};
          position: relative;
        }

        #clickArea {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 999
        }

        #clickArea img {
            border: 0
        }

        #banner {
            -moz-box-sizing: border-box;
            -webkit-box-sizing: border-box;
            -webkit-user-select: none;
            -ms-user-select: none;
            user-select: none;
            box-sizing: border-box;
            overflow: hidden;
            position: relative;
            width: ${banner.width}px;
            height: ${banner.height}px;
            top: 0;
            left: 0;
            cursor: pointer;
            background-color: ${banner.backgroundColor === undefined ? '#fff' : banner.backgroundColor}
        }
        
        #banner:after {
          position: absolute;
          content: '';
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 900;
          background-color: ${banner.backgroundColor === undefined ? '#fff' : banner.backgroundColor}
      }

      body {
        overflow: hidden;
      }

      #banner:before {
          position: absolute;
          content: '';
          left: 0;
          top: 0;
          width: calc(100% - 2px);
          height: calc(100% - 2px);
          z-index: 901;
      }`

  banner.elements.forEach(async (el) => {
    if (el.step > -1) {
      html += `
      .${el.id} {
        ${el.properties.background ? `background: url('${el.properties.background}') no-repeat;` : ""}        
        width: ${Math.ceil(el.properties.width * el.properties.scale / 100)}px;
        height: ${Math.ceil(el.properties.height * el.properties.scale / 100)}px;
        left: ${el.properties.left}px;
        top: ${el.properties.top}px;
        position: absolute;
        opacity: ${el.properties.opacity};
        z-index: ${el.properties.zIndex};
        ${el.reduce ? '' : 'background-size: contain;'}
      }`  
    }
  });
  html += "</style>";
  html += banner.animation;
  html += "</head>";
  html += banner.body;
  html += "</html>";
  return html;
}

export function BuildHTMLVideo(banner) {
  let delays = getDelays(banner.timeline);
  let html = banner.html + injectScript(delays);
  return html
    .replaceAll("animabanner();", "//animabanner();")
    .replaceAll("!important", "")
    .replaceAll("<a href=\"javascript:window.open(window.clickTag)\">", "")
    .replaceAll("</a>", "")
    .replace(
      `document.getElementById("sound-on").addEventListener("click", stopAudio)`,
      `document.getElementById("sound-on").style.display = 'none';`
      )
    .replace(
      `document.getElementById("sound-off").addEventListener("click", playAudio)`,
      `document.getElementById("sound-off").style.display = 'none';`);
}


function getDelays(timeline) {
  for (var i = timeline.length - 1; i >= 0; i--) {
    let delay = 0;
    for (var j = 0; j <= i; j++) {
      if (i === j || (!timeline[j].parent || timeline[j].parent === timeline[i].parent))
        delay += parseFloat(timeline[j].delay);
    }
    timeline[i].delay = (delay * 1000).toFixed(0);
  }
  return timeline;
}


function injectScript(delays) {
  var script = `<script type="text/javascript">
  function setTime(t) {
    const ids = [`

  delays.forEach(delay => {
    const animationName = delay.customKeyframe ? delay.animation :
    `${delay.animation}_${delay.direction}_${delay.duration}_${delay.type}`
    script += `{id: "${delay.name}", delay: ${delay.delay}, animation: "${animationName}", type: "${delay.type}", opacity: ${delay.type !== 'OUT'}},`
  });

  script += `]
    ids.forEach(id => {
      try {
        const delay = id.delay - t;
        let css = document.getElementsByClassName(id.id)[0];
        css.style['animationPlayState'] = 'paused'
        if (delay > 0) {
          css.style.opacity = 0;
        } else {
          try {
            if (id.type === "OUT" && !id.opacity) {
              id.opacity = true;
              css.style.opacity = 1;
            }
          } catch {}
          css.style.animationDelay = delay + 'ms';
          css.className = id.id + " " + id.animation;
        }
      } catch {}
    });
  }
  setTime(0)
</script>`
return script;
}


function getKeyframeName(css) {
  try {
    const k = css.toLowerCase().split("keyframes")[1].split("{")[0];
    const extractedText = k.replaceAll(" ", "");
    if (extractedText === "") return null;
    return extractedText;
  } catch {
    return null;
  }
}

function getDuration(css) {
  try {
    const regex = /\s\d+(\.\d+)?s/;
    const r = css.toLowerCase().split("animation:")[1].split("}")[0];
    const result = r.match(regex);
    const extractedText = result[0].replace("s", "");
    return parseFloat(extractedText).toFixed(1) * 1000;
  } catch {
    return null;
  }
}

export function getCustomKeyframe(css) {
  var res = {
    animationName: null,
    duration: null
  };
  res.animationName = getKeyframeName(css);
  res.duration = getDuration(css);
  return res;
}

export function verifyAnimation(copyMaster) {
  const erros = []
  if (!copyMaster.customKeyframe) return {master: copyMaster, erros: erros};
  copyMaster.customKeyframe.forEach(custom => {
    var aux = false;
    copyMaster.elements.forEach(element => {
      if (element.animation.in.animation === custom.animation || element.animation.out.animation === custom.animation) {
        aux = true;
      }
    });
    if ((custom.duration === null || custom.keyframeName == null) && aux) {
      const animation = getCustomKeyframe(custom.keyframe);
      if (animation.animationName && animation.duration) {
        custom.keyframeName = animation.animationName;
        custom.duration = animation.duration;
        copyMaster.preset.forEach(preset => {
          if (preset.customKeyframe && preset.customKeyframe.animation === custom.animation) {
            preset.customKeyframe.keyframeName = custom.keyframeName;
          }
        });
      } else {
        erros.push(custom.animation)
      }
    }
  });
  return {master: copyMaster, erros: erros}
}
